export default [
    {
        "Request_Id": 160058,
        "cid": "3075",
        "Cust_Info": {
            "Cust_ID": "3075",
            "Cust_Name": "AHMAD KAMARUL ZAMAN BIN ZAKARIA",
            "Cust_DOB": "1982-12-19",
            "Cust_Age": "40",
            "Max_Tenure_Year": "30"
        },
        "Bank_Info": [
            {
                "Report_Id": 258,
                "Bank_Id": 2,
                "Bank_Code": "ALB",
                "Bank_Name": "Alliance Bank",
                "Fintos_Score": 775,
                "Loan_Interest": 3.11,
                "Loan_Eligible": "1405867.00"
            },
            {
                "Report_Id": 258,
                "Bank_Id": 14,
                "Bank_Code": "MBSB",
                "Bank_Name": "MBSB",
                "Fintos_Score": 749,
                "Loan_Interest": 4.26,
                "Loan_Eligible": "1118725.00"
            },
            {
                "Report_Id": 258,
                "Bank_Id": 26,
                "Bank_Code": "ABM",
                "Bank_Name": "Affin Bank",
                "Fintos_Score": 645,
                "Loan_Interest": 3.0,
                "Loan_Eligible": "1317481.00"
            },
            {
                "Report_Id": 258,
                "Bank_Id": 3,
                "Bank_Code": "RHB",
                "Bank_Name": "RHB Bank",
                "Fintos_Score": 612,
                "Loan_Interest": 3.1,
                "Loan_Eligible": "1299882.00"
            },
            {
                "Report_Id": 258,
                "Bank_Id": 23,
                "Bank_Code": "AIA",
                "Bank_Name": "AIA",
                "Fintos_Score": 593,
                "Loan_Interest": 3.55,
                "Loan_Eligible": "1123147.00"
            },
        ],
    }
];